<script lang="ts">
import {ref} from "vue";
const openclassWithoutAnimation = ref(false);
</script>
<script lang="ts" setup>
import {watch, ref} from "vue";

import FeatureAuswahlRow from "@km/components/productChange/FeatureAuswahlRow.vue";

const props = defineProps({
  preview_image_src:String,
  isopen:Boolean,
  features_zur_auswahl:Array,
  currently_selected_features:Array,
  open_animation:{
    type:Function,
    default:()=>{openclassWithoutAnimation.value = true}
  },
  close_animation:{
    type:Function,
    default:()=>{openclassWithoutAnimation.value = false}
  }
})
const emits = defineEmits(["createproduct", "changefeature"])
watch(() => props.isopen, isOpen => {
  if (isOpen) {
    props.open_animation()
  } else {
    props.close_animation()
  }
})

const closeProductFeature = () => props.close_animation()
</script>

<template>
  <div class="km__modules__productlistfeatures km__popup middle" :class="{'active':openclassWithoutAnimation}">
    <div class="km__popup--heading">
      <button class="km__button--back" type="button" name="back" @click="closeProductFeature" aria-label="back"></button>
      <button class="km__button--close" type="button" name="close" @click="closeProductFeature" aria-label="close"></button>
      <h2>{{ $t("konf_SelectProduktFeatures") }}</h2>
    </div>
    <div class="km__popup--content">
      <div class="header--features">{{ $t("konf_featureauswahlSubHeader") }}</div>
      <div class="container--features" v-for="fo in features_zur_auswahl" v-bind:key="fo.FeaturedObject">
        <FeatureAuswahlRow
            :foname="fo.FeaturedObject"
            :features="fo.Features"
            :selected_features="currently_selected_features"
            @changefeature="feature=>$emit('changefeature', {fo:fo.FeaturedObject, feature})"
        />
        <div class="productpreview">
          <img :src="preview_image_src" alt="product preview">
        </div>
      </div>
      <button class="km__button--standard" @click="$emit('createproduct')">{{ $t("konf_Use") }}</button>
    </div>
  </div>
</template>



<style scoped lang="scss">
.km__modules__productlistfeatures {
  &.active {
    display: block;
  }
  display: none;
  z-index: 999;
  overflow-y: auto;
}

.header--features {
  font-size: 14px;
  line-height: 1.55em;
  padding-top: 20px;
  margin-bottom: 30px;
  font-weight: 600;
}

.productpreview {
  display: none;
}
</style>
